import { generateClient } from "aws-amplify/api";
import { updateHubSpotData } from "../graphql/mutations";

const client = generateClient();

const hubSpotService = {
  pushData: async (data) => {
    const response = await client.graphql({
      query: updateHubSpotData,
      variables: {
        data: JSON.stringify(data),
      },
      authMode: "userPool",
    });
    return response;
  },
};

export default hubSpotService;
